<template>
  <div>
    <div v-if="showType == 'form-builder'" :style="properties.style">
      <div>
        <h5 :style="properties.labelStyle">{{ properties.label }}</h5>
        <label>List</label>
        <span v-html="properties.listHeaderContent"></span>
        <div class="position-relative" :style="properties.listItemStyle">
          <fb-form-builder
            :json="properties.listItemLayout"
            :formId="formId"
            height="100px"
            @update-json="newJson => updateProperty('listItemLayout', newJson)"
            :isCrud="true"
          >
          </fb-form-builder>
          <!-- <img
            class="mt-1 mr-1 position-absolute delete-icon"
            :src="require('../../../../assets/icons/delete.svg')"
          /> -->
        </div>
      </div>
      <div>
        <label>Form</label>
        <div :style="properties.formStyle">
          <fb-form-builder
            :json="properties.formLayout"
            :formId="formId"
            height="100px"
            @update-json="newJson => updateProperty('formLayout', newJson)"
          >
          </fb-form-builder>
          <div class="d-flex flex-row justify-content-end">
            <b-button
              size="sm"
              class="mt-1 mb-1 mr-2 border-0 float-right"
              variant="primary"
              >{{
                computedConditions.addRecordLabel
                  ? computedPropertiesForm.addRecordLabel
                  : properties.addRecordLabel
              }}</b-button
            >
          </div>
        </div>
      </div>
    </div>
    <div v-if="showType == 'properties'">
      <crud-v1-properties :formId="formId" />
    </div>
    <div
      class=""
      v-if="
        (showType == 'form-submitter' && page == currentPage)|| showType == 'e-form'
      "
      :style="properties.style"      
      v-show="!computedHidden"
    >
      <strong :style="properties.labelStyle">
        {{
          computedConditions.label
            ? computedPropertiesForm.label
            : properties.label
        }}
      </strong>
      <div>
        <span
          v-html="computedPropertiesForm.listHeaderContent"
        ></span>
        <div
          :style="properties.listItemStyle"
          v-for="(value, valueIndex) in controlValue"
          :key="valueIndex"
          class="mb-1 rounded position-relative"
        >
          <fb-form-viewer
            :json="properties.listItemLayout"
            :showType="showType"
            :componentsIdSuffix="
              componentIdSuffix + '_' + (valueIndex + 1).toString()
            "
            :form="form"
            :results="form ? form.results : null"
            :ref="'item' + valueIndex"
          ></fb-form-viewer>
          <b-button
            class="mt-1 mr-1 position-absolute delete-button"
            v-if="properties.removeRecordLabel && showType == 'form-submitter'"
            variant="outline-danger"
            @click="deleteItem(valueIndex)"
            :style="properties.listItemDeleteStyle"
          >
            <img
              class="mr-1 delete-button-icon"
              :src="require('../../../../assets/icons/delete.svg')"
            />
            {{ properties.removeRecordLabel }}
          </b-button>
          <img
            v-else-if="showType == 'form-submitter'"
            class="mt-1 mr-1 position-absolute delete-icon"
            :src="require('../../../../assets/icons/delete.svg')"
            @click="deleteItem(valueIndex)"
            :style="properties.listItemDeleteStyle"
          />
        </div>
        <div class="my-3 mx-1">
          <span
            v-if="showType == 'form-submitter'"
            class="hover-pointer text-primary"
            :style="properties.addRecordLabelStyle"
            @click="showHideForm"
            >{{
              computedConditions.addRecordLabel
                ? computedPropertiesForm.addRecordLabel
                : properties.addRecordLabel
            }}</span
          >
        </div>
        <div
          :style="{
            ...properties.formStyle,
            ...{ display: showForm ? 'block' : 'none' }
          }"
        >
          <fb-form-viewer
            :json="properties.formLayout"
            :showType="showType"
            @update-child-control-value="updateControlValue"
            :componentsIdSuffix="componentIdSuffix + '_' + '0'"
            :form="form"
            :results="form ? form.results : null"
          ></fb-form-viewer>
          <div class="d-flex flex-row justify-content-end">
            <b-button
              v-if="showType == 'form-submitter'"
              size="sm"
              class="mt-1 mb-1 mr-2 border-0 float-right"
              variant="primary"
              @click="addRecord"
              >{{
                computedConditions.addRecordLabel
                  ? computedPropertiesForm.addRecordLabel
                  : properties.addRecordLabel
              }}</b-button
            >
          </div>
        </div>
      </div>
    </div>
    <b-form-group
      v-if="
        showType == 'form-viewer'
      "
      :label="
        computedConditions.label
          ? computedPropertiesForm.label
          : properties.label
      "
    >
      <div>
        <span
          v-html="computedPropertiesForm.listHeaderContent"
        ></span>
        <div
          :style="properties.listItemStyle"
          v-for="(value, valueIndex) in controlValue"
          :key="valueIndex"
          class="page-break-print mb-1 mt-2 rounded position-relative"
        >
          <fb-form-viewer
            :json="properties.listItemLayout"
            showType="form-viewer"
            :componentsIdSuffix="
              componentIdSuffix + '_' + (valueIndex + 1).toString()
            "
            :form="form"
            :results="form ? form.results : null"
          ></fb-form-viewer>
        </div>
      </div>
    </b-form-group>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState, mapActions } from "vuex";
import CrudV1Properties from "./CrudV1Properties.vue";
export default {
  name: "CrudV1",
  components: { CrudV1Properties },
  props: [
    "showType",
    "properties",
    "form",
    "formId",
    "id",
    "componentsIdSuffix",
    "results",
    "page"
  ],
  data() {
    return {
      childValues: {},
      computedProperties: ["addRecordLabel", "label", "hidden"],
      computedConditions: {},
      showForm: false
    };
  },
  mounted() {
    this.computeConditions();
    if(this.componentsIdSuffix) {
        this.initializeComponentValue({
          controlId: this.id,
          properties: this.properties
        });
      }
  },
  methods: {
     ...mapMutations("formSubmitter", ["setOneTimeBindingValues"]),
    ...mapActions("formSubmitter", ["setFormSubmitterComponentValue", "computeFormSubmitterValue", "initializeComponentValue"]),
    computeConditions() {
      const computedConditions = {};
      for (let index = 0; index < this.computedProperties.length; index++) {
        const property = this.computedProperties[index];
        computedConditions[property] =
          typeof this.properties[property] == "string" &&
          this.properties[property].includes("{{");
      }
      this.computedConditions = computedConditions;
    },
    updateProperty(field, newValue) {
      const newProperties = { ...this.properties };
      newProperties[field] = newValue;
      this.$emit("update-properties", newProperties);
    },
    addRecord() {
      const newControlValue = [...this.controlValue];
      newControlValue.push(this.childValues);
      this.controlValue = newControlValue;
      for (
        let index = 0;
        index < Object.keys(this.childValues).length;
        index++
      ) {
        const childId = Object.keys(this.childValues)[index];
        this.setFormSubmitterComponentValue({
          controlId: childId,
          controlValue: "",
          userAction: true
        });
      }
      this.childValues = {};
      this.showForm = false;
    },
    updateControlValue({ controlId, controlValue }) {
      this.childValues[controlId] = controlValue;
    },
    deleteItem(valueIndex) {
      this.$dialog
        .confirm(
          {
            title: "Are you sure you want to delete this item?"
          },
          {
            view: "confirm-delete"
          }
        )
        .then(async () => {
          this.removeChildValues(
            this.properties.listItemLayout,
            valueIndex,
            this.controlValue.length,
            this.componentIdSuffix
          );
          const newControlValue = [...this.controlValue];
          newControlValue.splice(valueIndex, 1);
          this.controlValue = newControlValue;
          this.childValues = {};
        })
        .catch(function() {});
    },
    removeChildValues(layout, valueIndex, valuesLength, componentIdSuffix) {
      let newOneTimeBindingValues = { ...this.oneTimeBindingValues };
      newOneTimeBindingValues = this.deleteOneTimeBindingValues(
        this.properties.formLayout,
        newOneTimeBindingValues
      );
      for (let index = 0; index < layout.rows.length; index++) {
        const row = layout.rows[index];
        for (let index2 = 0; index2 < row.columns.length; index2++) {
          const column = row.columns[index2];
          for (let index3 = 0; index3 < column.components.length; index3++) {
            const component = column.components[index3];
            newOneTimeBindingValues = this.removeFromOneTimeBindingValues(
              newOneTimeBindingValues,
              component.id
            );
            const componentId =
              component.id + componentIdSuffix + "_" + (valueIndex + 1);
            if (this.getFormSubmitterComponentValue(componentId)) {
              for (
                let index4 = valueIndex + 1;
                index4 < valuesLength;
                index4++
              ) {
                if (component.id.substring(0, 4) == "Crud") {
                  const prevControlValue = [
                    ...this.getFormSubmitterComponentValue(
                      component.id + "_" + index4
                    )
                  ];
                  const controlValue = [
                    ...this.getFormSubmitterComponentValue(
                      component.id + "_" + (index4 + 1)
                    )
                  ];
                  newOneTimeBindingValues = this.deleteOneTimeBindingValues(
                    component.properties.formLayout,
                    newOneTimeBindingValues
                  );
                  newOneTimeBindingValues = this.moveBackChildValues(
                    component.properties.listItemLayout,
                    index4,
                    Math.max(controlValue.length, prevControlValue.length),
                    newOneTimeBindingValues
                  );
                  const newControlValue = [];
                  for (let index5 = 0; index5 < controlValue.length; index5++) {
                    const componentValue = controlValue[index5];
                    const newComponentItemValue = {};
                    for (
                      let index6 = 0;
                      index6 < Object.keys(componentValue).length;
                      index6++
                    ) {
                      const componentItemValue = Object.keys(componentValue)[
                        index6
                      ];
                      const componentItemValueId = componentItemValue.split(
                        "_"
                      )[0];
                      newComponentItemValue[
                        componentItemValueId + "_" + index4 + "_0"
                      ] =
                        componentValue[
                          componentItemValueId + "_" + (index4 + 1) + "_0"
                        ];
                    }
                    newControlValue.push(newComponentItemValue);
                  }
                  this.setFormSubmitterComponentValue({
                    controlId: component.id + "_" + index4,
                    controlValue: newControlValue,
                    userAction: true
                  });
                } else {
                  this.setFormSubmitterComponentValue({
                    controlId: component.id + componentIdSuffix + "_" + index4,
                    controlValue: this.getFormSubmitterComponentValue(
                      component.id + componentIdSuffix + "_" + (index4 + 1)
                    ),
                    userAction: true
                  });
                }
              }
              this.setFormSubmitterComponentValue({
                controlId:
                  component.id + componentIdSuffix + "_" + valuesLength,
                controlValue: "",
                userAction: true
              });
            }
          }
        }
      }
      this.setOneTimeBindingValues({
        oneTimeBindingValues: newOneTimeBindingValues
      });
    },
    removeFromOneTimeBindingValues(oneTimeBindingValues, componentId) {
      const oneTimeBindingkeys = Object.keys(oneTimeBindingValues);
      const toDelete = oneTimeBindingkeys.filter(key =>
        key.startsWith(componentId)
      );
      for (let index = 0; index < toDelete.length; index++) {
        const key = toDelete[index];
        delete oneTimeBindingValues[key];
      }
      return oneTimeBindingValues;
    },
    moveBackChildValues(
      layout,
      valueIndex,
      valuesLength,
      newOneTimeBindingValues
    ) {
      for (let index = 0; index < layout.rows.length; index++) {
        const row = layout.rows[index];
        for (let index2 = 0; index2 < row.columns.length; index2++) {
          const column = row.columns[index2];
          for (let index3 = 0; index3 < column.components.length; index3++) {
            const component = column.components[index3];
            newOneTimeBindingValues = this.removeFromOneTimeBindingValues(
              newOneTimeBindingValues,
              component.id
            );
            for (let index4 = 0; index4 < valuesLength; index4++) {
              const componentValue = this.getFormSubmitterComponentValue(
                component.id + "_" + (valueIndex + 1) + "_" + (index4 + 1)
              );

              this.setFormSubmitterComponentValue({
                controlId: component.id + "_" + valueIndex + "_" + (index4 + 1),
                controlValue: componentValue ? componentValue : "",
                userAction: true
              });
            }
          }
        }
      }
      return newOneTimeBindingValues;
    },
    deleteOneTimeBindingValues(layout, newOneTimeBindingValues) {
      for (let index = 0; index < layout.rows.length; index++) {
        const row = layout.rows[index];
        for (let index2 = 0; index2 < row.columns.length; index2++) {
          const column = row.columns[index2];
          for (let index3 = 0; index3 < column.components.length; index3++) {
            const component = column.components[index3];
            newOneTimeBindingValues = this.removeFromOneTimeBindingValues(
              newOneTimeBindingValues,
              component.id
            );
          }
        }
      }
      return newOneTimeBindingValues;
    },
    getComponentComputedProperties(property) {
      return this.computedPropertiesForm
        ? this.computedPropertiesForm[property] != null
          ? this.computedPropertiesForm[property]
          : this.properties[property]
          ? this.properties[property]
          : ""
        : this.properties[property]
        ? this.properties[property]
        : "";
    },
    getBakedLayout() {
      const hidden = this.getComponentComputedProperties(
        "hidden"
      );

      if(hidden === true)
        return "";
        
      for (
        let index = 0;
        index < Object.keys(this.childValues).length;
        index++
      ) {
        const childId = Object.keys(this.childValues)[index];
        this.setFormSubmitterComponentValue({
          controlId: childId,
          controlValue: "",
          userAction: true
        });
      }
      const self = this;
      return `
      <fieldset aria-describedby="" class="">
        <legend tabindex="-1" class="bv-no-focus-ring col-form-label pt-0">${this.getComponentComputedProperties(
          "label"
        )}</legend>
        <div tabindex="-1" role="group" class="bv-no-focus-ring">
          <div>
            <span>${this.getComponentComputedProperties(
              "listHeaderContent"
            )}</span>
            ${(this.controlValue || [])
              .map((item, itemIndex) => {
                return `
            <div class="mb-1 mt-2 rounded position-relative" style="${self.getComponentComputedProperties(
              "listItemStyle"
            )}">
              ${self.$refs[`item${itemIndex}`][0].getBakedLayout()}
            </div>
            `;
              })
              .join("")}
          </div>
        </div>
      </fieldset>`;
    },
    showHideForm() {
      if (this.properties.addEmptyRecord) {
        this.addRecord();
        return;
      }
      this.showForm = !this.showForm;
    }
  },
  computed: {
    ...mapGetters("formSubmitter", [
      "getFormSubmitterComponentValue"
    ]),
    ...mapState("formSubmitter", {
      oneTimeBindingValues: state => {
        return state.form.oneTimeBindingValues;
      },
      currentPage: state => state.form.currentPage
    }),
    computedPropertiesForm() {
      return this.$store.state.formSubmitter.form.computedProperties[this.id] ?? this.properties;
    },
    controlValue: {
      get() {
        let resultControlValue = [];
        if (this.results) return this.results[this.id];
        const formSubmitterComponentValue = this.getFormSubmitterComponentValue(
          this.id
        );
        if (formSubmitterComponentValue)
          resultControlValue = formSubmitterComponentValue;
        return resultControlValue;
      },
      set(newControlValue) {
        if (this.controlValue != newControlValue) {
          this.setFormSubmitterComponentValue({
            controlId: this.id,
            controlValue: newControlValue,
            userAction: true,
            hardSet: true
          });
          this.$emit("update-child-control-value", {
            controlId: this.id,
            controlValue: newControlValue
          });
          if (this.properties.onChange) {
            this.computeFormSubmitterValue({
              elementId: this.id,
              property: "onChange",
              value: `computed:(${this.properties.onChange})(${JSON.stringify(
                newControlValue
              )})`,
              defaultValue: null,
              form: this.form,
              statements: true
            });
          }
        }
      }
    },
    componentIdSuffix() {
      return this.componentsIdSuffix ? this.componentsIdSuffix : "";
    },
    computedHidden(){
      const hiddenValue = this.computedConditions.hidden
        ? this.computedPropertiesForm.hidden
        : this.properties.hidden

      this.$emit("change-hidden-property", hiddenValue);
      return hiddenValue;
    }
  }
};
</script>

<style scoped>
.main-container {
  border-color: #d8d8d8 !important;
  background-color: #fafafa;
}
.delete-icon {
  top: 10px;
  right: 10px;
  width: 20px;
  height: 20px;
}
.delete-icon:hover {
  cursor: pointer;
}
.delete-button {
  top: 1px;
  right: 9px;
}
.delete-button-icon {
  width: 20px;
  height: 20px;
}

@media print {
  .page-break-print {
    page-break-inside: avoid;
  }
}
</style>
